module.exports = __webpack_public_path__ + "r-v3/img/ico_check_white.26b884fc.svg";